import React, { useState } from 'react';
import { validateTransferCode, importTransferData } from '../lib/deviceTransfer';
import { COLORS, SPACING } from '../styles/theme';

interface ImportConfirmProps {
  prefillCode?: string;
  onImported: () => void;
  onCancel: () => void;
}

export function ImportConfirm({ prefillCode = '', onImported, onCancel }: ImportConfirmProps) {
  const [code, setCode] = useState(prefillCode);
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    setLoading(true);
    setError('');
    const data = await validateTransferCode(code.trim(), passphrase);
    if (!data) {
      setError('Invalid code or wrong passphrase.');
      setLoading(false);
      return;
    }
    importTransferData(data);
    onImported();
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', backgroundColor: COLORS.bg, padding: SPACING.lg,
      fontFamily: '"IBM Plex Mono", monospace',
    }}>
      <div style={{ border: `2px outset ${COLORS.highlight}`, backgroundColor: COLORS.panel, maxWidth: 420, width: '100%', overflow: 'hidden' }}>
        <div style={{ backgroundColor: COLORS.accent, color: '#fff', padding: `${SPACING.sm} ${SPACING.lg}`, fontSize: '10px', fontWeight: 700 }}>
          Authenticulture — Import Account
        </div>

        <div style={{ padding: SPACING.lg }}>
          <p style={{ margin: `0 0 ${SPACING.lg} 0`, fontSize: '10px', color: COLORS.text, lineHeight: 1.6 }}>
            {prefillCode
              ? 'Transfer link detected. Enter the passphrase you set when generating it.'
              : 'Paste the transfer code from your other device, then enter the passphrase.'}
          </p>

          {!prefillCode && (
            <textarea
              value={code}
              onChange={e => { setCode(e.target.value); setError(''); }}
              placeholder="Paste transfer code here"
              style={{
                width: '100%', padding: SPACING.md, minHeight: 80,
                backgroundColor: '#fff', color: '#000',
                border: `2px inset ${COLORS.highlight}`,
                fontFamily: '"IBM Plex Mono", monospace', fontSize: '9px',
                boxSizing: 'border-box', resize: 'vertical', marginBottom: SPACING.sm,
              }}
            />
          )}

          <input
            type="password"
            placeholder="Passphrase"
            value={passphrase}
            onChange={e => { setPassphrase(e.target.value); setError(''); }}
            style={{
              width: '100%', padding: SPACING.md,
              backgroundColor: '#fff', color: '#000',
              border: `2px inset ${COLORS.highlight}`,
              fontFamily: '"IBM Plex Mono", monospace', fontSize: '10px',
              boxSizing: 'border-box', marginBottom: SPACING.sm,
            }}
          />

          {error && <p style={{ margin: `0 0 ${SPACING.sm} 0`, fontSize: '9px', color: COLORS.accent }}>{error}</p>}

          <div style={{ display: 'flex', gap: SPACING.sm }}>
            <button
              onClick={handle}
              disabled={loading || !code.trim() || !passphrase}
              style={{
                flex: 1, padding: SPACING.md,
                background: code.trim() && passphrase ? COLORS.accent : COLORS.panel,
                color: code.trim() && passphrase ? '#fff' : COLORS.textMuted,
                border: `2px outset ${code.trim() && passphrase ? COLORS.accent : COLORS.border}`,
                cursor: code.trim() && passphrase ? 'pointer' : 'default',
                fontFamily: '"IBM Plex Mono", monospace', fontSize: '10px', fontWeight: 700,
              }}
            >
              {loading ? '...' : 'Import account'}
            </button>
            <button onClick={onCancel}
              style={{ padding: SPACING.md, background: 'transparent', border: `2px outset ${COLORS.highlight}`, color: COLORS.textMuted, cursor: 'pointer', fontFamily: '"IBM Plex Mono", monospace', fontSize: '10px' }}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
